import React from 'react';
import './Menu.css';
import TranslatedText from './TranslatedText';

export const Menu = props => <nav className="MenuBottom">{props.children}</nav>;

export const MenuItem = props => (
    <button
        className={`MenuBottom-button ${
            props.active ? 'MenuBottom-button__active' : ''
        }`}
        onClick={props.onClick}>
        <TranslatedText tag={props.tag} />
    </button>
);



// WEBPACK FOOTER //
// ./src/atoms/Menu.js